export { default } from './Certificate';
